import React, { useEffect, useRef } from "react";
import { useAuth } from "@/store/authStore";
import { loginWithTelegramId } from "@/api/auth";
import { fetchMe } from "@/api/users";

export const WebAuthProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { accessToken, setMe, setInitData } = useAuth();
  const processedTelegramIdRef = useRef<string | null>(null);

  useEffect(() => {
    setInitData(null);
  }, [setInitData]);

  useEffect(() => {
    let cancelled = false;
    const telegramId = new URLSearchParams(window.location.search).get(
      "telegram_id"
    );

    const run = async () => {
      try {
        const currentMe = useAuth.getState().me;
        const currentTelegramId =
          currentMe?.telegram_id === null || currentMe?.telegram_id === undefined
            ? null
            : String(currentMe.telegram_id);

        if (
          telegramId &&
          processedTelegramIdRef.current !== telegramId &&
          currentTelegramId !== telegramId
        ) {
          processedTelegramIdRef.current = telegramId;
          await loginWithTelegramId(telegramId);
        } else if (!accessToken) {
          if (!cancelled) setMe(null);
          return;
        }

        const data = await fetchMe();
        if (!cancelled) setMe(data);
      } catch {
        if (!cancelled) setMe(null);
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [accessToken, setMe]);

  return <>{children}</>;
};
